import { LivingSpaceRange } from '@immosky/types';
import { createAction, props } from '@ngrx/store';

export enum LivingSpaceActions {
  Reset = '[Filter] Reset Living Space Filter',
  Set = '[Filter] Set Living Space Filter',
  SetBasedOnValues = '[Filter] Set Living Space Filter Based On Values',
}

export const resetLivingSpaceFilter = createAction(LivingSpaceActions.Reset);

export const setLivingSpaceFilter = createAction(
  LivingSpaceActions.Set,
  props<{ filter: LivingSpaceRange }>()
);

export const setLivingSpaceFilterBasedOnUrlValues = createAction(
  LivingSpaceActions.SetBasedOnValues,
  props<{ values: { min: number; max: number } }>()
);
